import { computed, ref } from 'vue'
import { backButtonCallback } from '@/router'
import type { Nullable } from '@/types/shared/common'

const selectedGift = ref<Nullable<{ name?: string, lottie: string }>>(null)
export const useGiftModal = () => {
  const showGiftModal = computed(() => !!selectedGift.value)

  function hideGiftModal() {
    backButtonCallback.value = null
    selectedGift.value = null
  }

  function setSelectedGift(gift: { name?: string, lottie: string }) {
    backButtonCallback.value = hideGiftModal
    selectedGift.value = gift
  }

  return {
    showGiftModal,
    hideGiftModal,
    setSelectedGift,
    selectedGift,
  }
}